import * as yup from "yup";
import { Language } from "../../language/English";
import { NAME_MAX_LENGTH } from "./BusinessTypeConstant";

export const BusinessTypeValidation = () => {
    return yup.object().shape({
        name : yup.string().min(3).max(NAME_MAX_LENGTH).required().label(Language.BUSINESS_TYPE_NAME),
        url : yup.string().min(3).max(250).required().label(Language.URL),
    });
} 